import { defineFieldFormInterface } from "~/entities/field";
import FilesAliasType from "./FilesAliasType.vue";

export default defineFieldFormInterface({
  type: "alias",
  interface: "files",
  component: FilesAliasType,
});
